module.exports = __webpack_public_path__ + "img/spinb.09de59c9.png";